module.exports = __webpack_public_path__ + "img/cn-stu-t.81364209.png";